module.exports = __webpack_public_path__ + "img/overview-active.143195cf.svg";